/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewyourbusinessanalyticsandinsights5Inputs */

const en_viewyourbusinessanalyticsandinsights5 = /** @type {(inputs: Viewyourbusinessanalyticsandinsights5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View your business analytics and insights`)
};

const de_viewyourbusinessanalyticsandinsights5 = /** @type {(inputs: Viewyourbusinessanalyticsandinsights5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieh dir die Statistiken deines Unternehmens an.`)
};

/**
* | output |
* | --- |
* | "View your business analytics and insights" |
*
* @param {Viewyourbusinessanalyticsandinsights5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const viewyourbusinessanalyticsandinsights5 = /** @type {((inputs?: Viewyourbusinessanalyticsandinsights5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewyourbusinessanalyticsandinsights5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewyourbusinessanalyticsandinsights5(inputs)
	return de_viewyourbusinessanalyticsandinsights5(inputs)
});
export { viewyourbusinessanalyticsandinsights5 as "viewYourBusinessAnalyticsAndInsights" }